import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiFetch } from '../../api';
import { createTableSlice } from '../helpers';

export const tableSlice = createTableSlice({
  name: 'notifications/unseenTable',
  url: '/api/notifications',
  filters: {
    seen: 0,
  },
});

export const updateNotificationStatus = createAsyncThunk(
  'notifications/unseen/updateNotificationStatus',
  async ({ userId, notificationId, seen }, { dispatch }) => {
    const url = `/api/users/${userId}/notifications/${notificationId}`;
    await apiFetch(url, 'PATCH', { seen });
    dispatch(tableSlice.actions.fetchRows());
  }
);
